import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f765722"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-title" }, "地区选择", -1))
const _hoisted_2 = { class: "bread-crumbs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { style: {"line-height":"1.5"} }
const _hoisted_5 = { style: {"font-size":"12px","color":"#999","white-space":"normal"} }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_input, {
      modelValue: _ctx.selectedText,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedText) = $event)),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = true)),
      placeholder: "地区选择",
      "suffix-icon": !_ctx.modelValue ? 'el-icon-location' : '',
      clearable: true,
      onClear: _ctx.handleClear,
      size: _ctx.selectSizes,
      class: "input"
    }, null, 8, ["modelValue", "suffix-icon", "onClear", "size"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: "地区选择",
      "append-to-body": "",
      "custom-class": "area-popover"
    }, {
      title: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_el_row, {
          type: "flex",
          align: "middle"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 16 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  (_ctx.viewingPath.length === 0)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["bread-crumbs-item", { active: _ctx.currentLevel === 0 }])
                      }, " 请选择省份 ", 2))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewingPath, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["bread-crumbs-item selected", { active: _ctx.currentLevel === index }]),
                      key: item.code,
                      onClick: ($event: any) => (_ctx.currentLevel = index)
                    }, _toDisplayString(item.name), 11, _hoisted_3))
                  }), 128)),
                  (_ctx.viewingPath.length === 1 && _ctx.maxLevel > 1)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["bread-crumbs-item", { active: _ctx.currentLevel === 1 }]),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentLevel = 1))
                      }, " 请选择城市 ", 2))
                    : _createCommentVNode("", true),
                  (_ctx.viewingPath.length === 2 && _ctx.maxLevel > 2)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: _normalizeClass(["bread-crumbs-item", { active: _ctx.currentLevel === 2 }]),
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.currentLevel = 2))
                      }, " 请选择区县 ", 2))
                    : _createCommentVNode("", true),
                  (_ctx.viewingPath.length === 3 && _ctx.maxLevel > 3)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 3,
                        class: _normalizeClass(["bread-crumbs-item", { active: _ctx.currentLevel === 3 }]),
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.currentLevel = 3))
                      }, " 请选择街道 ", 2))
                    : _createCommentVNode("", true),
                  (_ctx.viewingPath.length === 4 && _ctx.maxLevel > 4)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 4,
                        class: _normalizeClass(["bread-crumbs-item", { active: _ctx.currentLevel === 4 }]),
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.currentLevel = 4))
                      }, " 请选择社区/居委会 ", 2))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_autocomplete, {
                  style: {"width":"100%"},
                  size: "small",
                  "prefix-icon": "el-icon-search",
                  placeholder: "请输入地区名称",
                  modelValue: _ctx.suggestionQuery,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.suggestionQuery) = $event)),
                  "value-key": "name",
                  clearable: "",
                  debounce: 300,
                  "fetch-suggestions": _ctx.fethSuggetion,
                  onSelect: _ctx.handleSuggestionSelected
                }, {
                  default: _withCtx(({item}) => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", null, _toDisplayString(item.name), 1),
                      _createElementVNode("div", _hoisted_5, _toDisplayString(item.parentsName), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "fetch-suggestions", "onSelect"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_el_row, {
          type: "flex",
          justify: "end",
          align: "middle"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_space, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      size: "small",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialogVisible = false))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small",
                      onClick: _ctx.handleConfirmSelected
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        (_ctx.currentNode.children.length === 0)
          ? _withDirectives((_openBlock(), _createBlock(_component_el_empty, { key: 0 }, null, 512)), [
              [_directive_loading, _ctx.loading]
            ])
          : (_openBlock(), _createBlock(_component_el_space, {
              key: 1,
              wrap: "",
              size: 5,
              class: "area-list"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentNode.children, (areaItem) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: areaItem.code,
                    onClick: ($event: any) => (_ctx.handleAreaSelected(areaItem)),
                    class: "area-item"
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["area-text", { active: _ctx.inSelectedPath(areaItem.code) }])
                    }, _toDisplayString(areaItem.name), 3)
                  ], 8, _hoisted_6))
                }), 128))
              ]),
              _: 1
            }))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}